import React from 'react';
import { cardDeadline, cardFacts, COMPETITIVENESS, priceText, programName, UNKNOWN_COST } from '../format';
import { ProgramCard } from '../types';

interface Props {
  p: ProgramCard;
  saved: boolean;
  /** Hidden for parents and counselors, who use their own actions. */
  onSave?: () => void;
  onOpen: () => void;
  onMoreFromFamily?: (familyName: string) => void;
  /** Extra action, e.g. "Suggest to Maya" for counselors. */
  action?: React.ReactNode;
}

export default function ProgramCardView({ p, saved, onSave, onOpen, onMoreFromFamily, action }: Props) {
  const price = priceText(p);
  const comp = p.competitivenessLabel ? COMPETITIVENESS[p.competitivenessLabel] : null;
  const name = programName(p);
  const stop = (e: React.MouseEvent) => e.stopPropagation();
  return (
    <article
      className="card pcard"
      onClick={onOpen}
      onKeyDown={(e) => (e.key === 'Enter' ? onOpen() : undefined)}
      tabIndex={0}
      aria-label={name}
    >
      <div style={{ minWidth: 0 }}>
        <h3 style={{ fontSize: 16 }}>{name}</h3>
        {p.institution && p.institution !== name && <div className="host">{p.institution}</div>}
        {p.description && <p className="desc">{p.description}</p>}
        <div className="row" style={{ marginTop: 10 }}>
          {p.topics.slice(0, 3).map((t) => (
            <span key={t.slug} className="chip">{t.name}</span>
          ))}
          {comp && <span className={`chip ${comp.tone}`} title={comp.help}>{comp.label}</span>}
          {p.paysStudents && <span className="chip ok">Pays students</span>}
        </div>
        <p className="facts" style={{ marginTop: 10 }}>{cardFacts(p)}</p>
        {p.family && p.family.more_count > 0 && onMoreFromFamily && (
          <button
            type="button"
            className="linkish"
            style={{ marginTop: 8, fontSize: 13 }}
            onClick={(e) => {
              stop(e);
              onMoreFromFamily(p.family!.name);
            }}
          >
            + {p.family.more_count} more from {p.family.name}
          </button>
        )}
      </div>
      <div className="side">
        {price.free ? <span className="chip ok">Free</span> : price.text === UNKNOWN_COST ? <span className="muted small">{UNKNOWN_COST}</span> : <b style={{ fontWeight: 500 }}>{price.text}</b>}
        <span className="muted small">{cardDeadline(p)}</span>
        <div className="row" onClick={stop} style={{ justifyContent: 'flex-end' }}>
          {action}
          {onSave && (
            <button type="button" className={`btn sm ${saved ? '' : 'primary'}`} onClick={onSave} aria-pressed={saved}>
              {saved ? 'Saved' : 'Save'}
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
